#import "../fragments/mcfx-audience-fragment.graphql"

query GetMcfxAudiencesFromApi {
    mcfxAudiencesViaApi {
        ...McfxAudienceFragment
    }
}
